import { Slider, styled } from '@mui/material';
import { BaseCard, BaseCardLabel } from 'console/shared/styles/mixins/base-card';
export const Thermometer = styled(BaseCard)(({ theme }) => ({
    display: 'flex',
    minHeight: 70,
    height: '100%',
    onClick: open,
    padding: 8,
    columnGap: 8,
    borderRadius: 12,
    cursor: 'pointer',
    WebkitTapHighlightColor: 'transparent',
}));
export const ThermometerLabel = styled(BaseCardLabel)({});
export const ThermometerView = styled(Slider, {
    shouldForwardProp: (prop) => prop !== 'no_connection',
})(({ no_connection }) => ({
    width: 3.5,
    margin: '0 10px',
    padding: '0 12px !important',
    boxSizing: 'border-box',
    pointerEvents: 'none',
    '& .MuiSlider-thumb': {
        width: 7,
        height: 7,
        left: 26,
        display: no_connection ? 'none' : 'flex',
    },
    '& .MuiSlider-track': {
        width: 5,
    },
    '& .MuiSlider-rail, .MuiSlider-track': {
        margin: '0 14px',
    },
    '& input[type="range"]': {
        WebkitAppearance: 'slider-vertical',
    },
    '& .MuiSlider-markActive': {
        display: 'none',
    },
    '& .MuiSlider-mark': {
        display: 'none',
    },
    '& .MuiSlider-markLabel': {
        fontSize: '0.5em',
        left: '-4px',
        '&[data-index="0"]': {
            bottom: '10% !important',
        },
        '&[data-index="1"]': {
            bottom: '90% !important',
        },
    },
}));
